module.exports = __webpack_public_path__ + "img/12.a9fd1bb3.jpg";